module.exports = __webpack_public_path__ + "img/auth-v2-reset-password-illustration-dark.cf4f7e0a.png";